"use client";

// ════════════════════════════════════════════════════════════════════════════
// GLOBAL ERROR — rede de segurança da raiz (29/08)
// ════════════════════════════════════════════════════════════════════════════
// Sem este arquivo, erro que escapa acima do boundary de /app cai no
// DefaultGlobalError do Next: "This page couldn't load — Reload to try again"
// em inglês, sem auto-recuperação. Foi exatamente o que os usuários viram na
// madrugada de 6 deploys (29/08): navegação RSC com build antigo estoura no
// nível do router, onde só o global-error pega.
//
// Mesma lógica do src/app/app/error.tsx: erro com cara de build velho (chunk /
// server action) → UM reload automático com trava de 20s (sessionStorage) para
// não entrar em loop; o resto mostra recuperação manual em português.
//
// ⚠️ Contrato do Next: global-error substitui o layout raiz INTEIRO — precisa
// renderizar <html> e <body> próprios.

const TRAVA = "meucdn:global-error-reload";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  const msg = String(error?.message ?? "");
  // BUILD VELHO tem assinatura ESPECÍFICA: chunk/action que sumiu no deploy. NÃO
  // é "qualquer erro sem digest" (a heurística anterior — foi ela que mascarou um
  // ReferenceError real de servidor como 'painel atualizado' e me cegou por horas
  // em 30/08). Erro COM digest é bug de servidor genuíno: mostra como tal, com a
  // ref, e NÃO recarrega sozinho (recarregar não conserta bug de código).
  const buildVelho =
    /ChunkLoadError|Loading chunk|Failed to find Server Action|Failed to fetch|error loading dynamically imported module/i.test(msg);

  if (typeof window !== "undefined" && buildVelho) {
    const ultima = Number(sessionStorage.getItem(TRAVA) ?? 0);
    if (Date.now() - ultima > 20_000) {
      sessionStorage.setItem(TRAVA, String(Date.now()));
      window.location.reload();
    }
  }

  const titulo = buildVelho ? "O painel foi atualizado" : "Algo deu errado";
  const desc = buildVelho
    ? "Esta aba estava com uma versão antiga. Recarregue para continuar de onde parou."
    : "Encontramos um erro ao carregar esta tela. Recarregue; se persistir, avise o suporte com a referência abaixo.";

  return (
    <html lang="pt-BR">
      <body style={{ margin: 0, fontFamily: "ui-sans-serif, system-ui, sans-serif", background: "#fafafa", color: "#0a0a0a" }}>
        <div style={{ minHeight: "100svh", display: "grid", placeItems: "center", padding: 24 }}>
          <div style={{ maxWidth: 440, textAlign: "center" }}>
            <p style={{ fontSize: 15, fontWeight: 600, margin: "0 0 6px" }}>{titulo}</p>
            <p style={{ fontSize: 13.5, color: "#737373", lineHeight: 1.55, margin: "0 0 18px" }}>{desc}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{ font: "inherit", fontSize: 13.5, fontWeight: 600, padding: "9px 22px", borderRadius: 10, border: 0, background: "#7c3aed", color: "#fff", cursor: "pointer" }}
            >
              Recarregar
            </button>
            {error?.digest ? <p style={{ fontSize: 11, color: "#a3a3a3", marginTop: 16 }}>ref {error.digest}</p> : null}
          </div>
        </div>
      </body>
    </html>
  );
}
